import { QueryKeyType } from '@insights_module/types/QueryKeys';

export const INSIGHTS_QUERY_KEY = {
  title: 'title' as QueryKeyType,
  include_keywords: 'include_keywords' as QueryKeyType,
  exclude_keywords: 'exclude_keywords' as QueryKeyType,
  include_named_entities: 'include_named_entities' as QueryKeyType,
  exclude_named_entities: 'exclude_named_entities' as QueryKeyType,
  include_topics: 'include_topics' as QueryKeyType,
  exclude_topics: 'exclude_topics' as QueryKeyType,
  include_text: 'include_text' as QueryKeyType,
  exclude_text: 'exclude_text' as QueryKeyType,
  duration: 'duration' as QueryKeyType,
  adult_explicit_content: 'adult_explicit_content' as QueryKeyType,
  arms_ammunition: 'arms_ammunition' as QueryKeyType,
  crime_harmful_act: 'crime_harmful_act' as QueryKeyType,
  death_injury_military_conflict: 'death_injury_military_conflict' as QueryKeyType,
  debated_social: 'debated_social' as QueryKeyType,
  hate_speech: 'hate_speech' as QueryKeyType,
  illegal_drugs: 'illegal_drugs' as QueryKeyType,
  obscenity: 'obscenity' as QueryKeyType,
  online_piracy: 'online_piracy' as QueryKeyType,
  spam_harmful: 'spam_harmful' as QueryKeyType,
  terrorism: 'terrorism' as QueryKeyType,
  name: 'name' as QueryKeyType,
  show: 'show' as QueryKeyType,
  groups: 'groups' as QueryKeyType,
  infinite_groups: 'infinite_groups' as QueryKeyType,
  infinite_episodes: 'infinite_episodes' as QueryKeyType,
  episodes_related_to_garm_date: 'episodes_related_to_garm_date' as QueryKeyType,
  episodes_related_to_garm_count: 'episodes_related_to_garm_count' as QueryKeyType,
  garm_result: 'garm_result' as QueryKeyType,
  episodes: 'episodes' as QueryKeyType,
  show_garm_results: 'show_garm_results' as QueryKeyType,
  shows_garm_results: 'shows_garm_results' as QueryKeyType,
  views: 'views' as QueryKeyType,
  contextual: 'contextual' as QueryKeyType,
  entities: 'entities' as QueryKeyType,
  export_csv: 'export_csv' as QueryKeyType,
  transcript: 'transcript' as QueryKeyType,
  diarized_transcript: 'diarized_transcript' as QueryKeyType,
  export_transcript: 'export_transcript' as QueryKeyType,
  export_diarized_transcript: 'export_diarized_transcript' as QueryKeyType,
  traceability_garm: 'traceability_garm' as QueryKeyType,
  traceability_iab: 'traceability_iab' as QueryKeyType,
  traceability_contextual: 'traceability_contextual' as QueryKeyType,
  episode_contextual: 'episode_contextual' as QueryKeyType,
  episode_entities: 'episode_entities' as QueryKeyType,
  episode_summary: 'episode_garm' as QueryKeyType,
  query_token: 'query_token' as QueryKeyType,
  flightpath_avails: 'flightpath_avails' as QueryKeyType,
  processed_audio_count: 'processed_audio_count' as QueryKeyType,
  selected_episode_garm: 'selected_episode_garm' as QueryKeyType,
  generate_aql_filter: 'generate_aql_filter' as QueryKeyType,
  generate_ai_content_for_episode: 'generate_ai_content_for_episode' as QueryKeyType,
  check_for_episode_gen_ai_content: 'check_for_episode_gen_ai_content' as QueryKeyType,
  episode_chapters: 'episode_chapters' as QueryKeyType,
  episode_topics: 'episode_topics' as QueryKeyType,
  episode_keywords: 'episode_keywords' as QueryKeyType,
  include_linked_named_entities: 'include_linked_named_entities' as QueryKeyType,
  exclude_linked_named_entities: 'exclude_linked_named_entities' as QueryKeyType,
};
